export default __webpack_public_path__ + "static/media/empty-gray-stroke.af315aa6.svg";